import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '@core/services/common.service';
import { UserService } from '@core/services/user.service';
import { LocaleService } from '@core/services/locale.service';
import { MaintenanceService } from '@core/services/maintenance.service';


@Component({
    selector: 'app-base',
    template: ``,
    styleUrls: [],
    standalone: false
})
export class BaseComponent {

  constructor(
    public router: Router,
    public commonService: CommonService,
    public userService: UserService,
    public localeService: LocaleService,
    public maintenanceService: MaintenanceService
  ) {

    this.maintenanceService.maintenanceMode$.subscribe(isMaintenance => {
      if (isMaintenance) {
        this.router.navigate(['/maintenance']);
        this.maintenanceService.isMaintenance = true;
      }
    });

    // TAKTO ALEBO EMIT NOTIFY ???
    this.userService.getLoggedUser().subscribe(user => {
      this.commonService.setLoggedUser(user);
    });
  }
}
